var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-title": "Abbrechen",
        "modal-class": "email-user-assignment-modal info-card editMode",
        "ok-disabled": !_vm.hasChanged,
        "ok-title": "Zuweisen",
        size: "md",
        title: "Bearbeiter zuweisen",
        visible: _vm.show,
      },
      on: {
        hidden: _vm.onHidden,
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onConfirm.apply(null, arguments)
        },
      },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center pt-4" },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "info-card-element",
                  attrs: {
                    label: "Bearbeiter",
                    "label-for": "reminder-date-input",
                  },
                },
                [
                  _c("csp-form-select-searchable", {
                    attrs: {
                      "allow-empty": true,
                      options: _vm.userOptions,
                      value: _vm.currentUserId,
                    },
                    on: { change: _vm.onUserChange },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }